var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.929 15C13.52 15 14 14.496 14 13.875v-3.75C14 9.504 13.52 9 12.929 9H7.393V6.584c0-.929.707-1.7 1.591-1.709.893-.01 1.623.752 1.623 1.688v.375c0 .311.239.562.536.562h.714c.297 0 .536-.25.536-.562v-.375c0-1.97-1.53-3.57-3.404-3.563-1.875.007-3.382 1.629-3.382 3.598V9h-.536C4.48 9 4 9.504 4 10.125v3.75C4 14.496 4.48 15 5.071 15h7.858z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/4a883b705c1d39b77035b7bca3ff68be-Unlock.svg";
export { SvgUnlock as ReactComponent };